module.exports = __webpack_public_path__ + "img/Realisme_Det_moderne_gjennombruddet2.71624d5d.jpg";